import React from 'react';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import MediaDeviceSelectPill from './MediaDeviceSelectPill';
import {
  DEFAULT_SPEAKER_ID,
  createStoredPreferenceHelpers,
} from './mediaDeviceSelectorUtils';

export const SESSION_STORAGE_KEY = 'oatrx.portalDelivery.selectedSpeaker';

const {
  defaultPreference,
  readPreference,
  persistPreference,
} = createStoredPreferenceHelpers({
  storageKey: SESSION_STORAGE_KEY,
  fallbackId: DEFAULT_SPEAKER_ID,
  fallbackLabel: 'Default speaker',
});

export const readStoredSpeakerPreference = readPreference;
export const persistSpeakerPreference = persistPreference;
export { DEFAULT_SPEAKER_ID };

const SpeakerSelector = (props) => (
  <MediaDeviceSelectPill
    {...props}
    kind="audiooutput"
    fallbackId={DEFAULT_SPEAKER_ID}
    fallbackLabel={defaultPreference.label}
    pillLabel="Speakers"
    Icon={VolumeUpRoundedIcon}
    readPreference={readPreference}
    persistPreference={persistPreference}
  />
);

export default SpeakerSelector;
